import RequestDemo from "../../../Button/RequestDemo";
import Text from "../../../commons/Text";
import Title from "../../../commons/Title";
import classes from "./index.module.scss";
import btnClasses from "../../../commons/Button.module.scss";

export default function Content({ title, text }) {
  return (
    <div className={classes.content}>
      <Title title={title} number={"01"} className={classes.title} />
      <Text text={text} className={classes.text} />
      <RequestDemo className={btnClasses.button} />
    </div>
  );
}
